/**
 * @generated SignedSource<<18bd6c70e5651aa3e70ae1ae1e22ec38>>
 * @relayHash bfd2d03b38af95faa0e469c18e1b2cf6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6cafaee2d45a7afc5e38c864a3f5ffe04fd5e96c5f5a758bfdeb45a38c0a88db

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluencePageSubType = "LIVE" | "%future added value";
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchConfluenceDocumentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type SearchConfluenceRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchContainerStatus = "ARCHIVED" | "CURRENT" | "%future added value";
export type SearchIssueStatusCategory = "DONE" | "INDETERMINATE" | "NEW" | "OPEN" | "UNDEFINED" | "%future added value";
export type SearchLinkedEntityGranularity = "ALL_MATCHING_MESSAGES" | "DEFAULT" | "FULL_THREAD" | "ONLY_LINKED_ENTITIES" | "%future added value";
export type SearchParticipantType = "COMMENTED" | "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "SHARED" | "VIEWED" | "%future added value";
export type SearchProjectType = "business" | "customer_service" | "product_discovery" | "service_desk" | "software" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
export type SearchSalesforceAttributeFilterOperator = "BETWEEN" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "%future added value";
export type SearchSalesforceAttributeFilterSource = "CUSTOM_PROPERTIES_DATE" | "CUSTOM_PROPERTIES_KEYWORD" | "CUSTOM_PROPERTIES_NUMBER" | "RELATIONSHIPS" | "%future added value";
export type SearchServiceNowAttributeFilterOperator = "BETWEEN" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "%future added value";
export type SearchServiceNowAttributeFilterSource = "ADD_ON_PROPERTIES_DATE" | "RELATIONSHIPS" | "%future added value";
export type SearchThirdPartyRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchFilterInput = {
  assetsFilters?: SearchAssetsFilter | null;
  commonFilters?: SearchCommonFilter | null;
  compassFilters?: SearchCompassFilter | null;
  confluenceFilters?: SearchConfluenceFilter | null;
  entities: ReadonlyArray<string>;
  externalFilters?: SearchExternalFilter | null;
  jiraFilters?: SearchJiraFilter | null;
  locations: ReadonlyArray<string>;
  mercuryFilters?: SearchMercuryFilter | null;
  talentFilters?: SearchTalentFilter | null;
  thirdPartyFilters?: SearchThirdPartyFilter | null;
  trelloFilters?: SearchTrelloFilter | null;
};
export type SearchAssetsFilter = {
  objectSchemaFilter?: SearchAssetsObjectSchemaFilter | null;
  objectTypeFilter?: SearchAssetsObjectTypeFilter | null;
};
export type SearchAssetsObjectSchemaFilter = {
  schemaARIs?: ReadonlyArray<string> | null;
};
export type SearchAssetsObjectTypeFilter = {
  typeARIs?: ReadonlyArray<string> | null;
};
export type SearchCommonFilter = {
  contributorsFilter?: ReadonlyArray<string> | null;
  participants?: SearchParticipants | null;
  range?: SearchCommonRangeFilter | null;
};
export type SearchParticipants = {
  combination: SearchCombinationType;
  items: ReadonlyArray<SearchParticipant>;
};
export type SearchParticipant = {
  combination: SearchCombinationType;
  type: SearchParticipantType;
  users: ReadonlyArray<string>;
};
export type SearchCommonRangeFilter = {
  created?: SearchCommonRangeFilterFields | null;
  lastModified?: SearchCommonRangeFilterFields | null;
};
export type SearchCommonRangeFilterFields = {
  gt?: string | null;
  lt?: string | null;
};
export type SearchCompassFilter = {
  componentFilter?: SearchCompassComponentFilter | null;
};
export type SearchCompassComponentFilter = {
  componentStates: ReadonlyArray<string>;
};
export type SearchConfluenceFilter = {
  ancestorIdsFilter?: ReadonlyArray<string> | null;
  containerARIs?: ReadonlyArray<string> | null;
  containerStatus?: ReadonlyArray<SearchContainerStatus | null> | null;
  contentStatuses?: ReadonlyArray<SearchConfluenceDocumentStatus> | null;
  contributorsFilter?: ReadonlyArray<string> | null;
  creatorsFilter?: ReadonlyArray<string> | null;
  isVerified?: boolean | null;
  labelsFilter?: ReadonlyArray<string> | null;
  mentions?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  pageStatus?: ReadonlyArray<string> | null;
  range?: ReadonlyArray<SearchConfluenceRangeFilter | null> | null;
  spacesFilter?: ReadonlyArray<string> | null;
  titleMatchOnly?: boolean | null;
};
export type SearchConfluenceRangeFilter = {
  field: SearchConfluenceRangeField;
  gt?: string | null;
  lt?: string | null;
};
export type SearchExternalFilter = {
  containers?: ReadonlyArray<SearchExternalContainerFilter | null> | null;
  contentFormats?: ReadonlyArray<SearchExternalContentFormatFilter | null> | null;
  depth?: ReadonlyArray<SearchExternalDepthFilter | null> | null;
};
export type SearchExternalContainerFilter = {
  type: string;
  values: ReadonlyArray<string>;
};
export type SearchExternalContentFormatFilter = {
  type: string;
  values: ReadonlyArray<string>;
};
export type SearchExternalDepthFilter = {
  depth: number;
  type: string;
};
export type SearchJiraFilter = {
  boardFilter?: SearchBoardFilter | null;
  issueFilter?: SearchJiraIssueFilter | null;
  projectFilter?: SearchJiraProjectFilter | null;
};
export type SearchBoardFilter = {
  negateProjectFilter?: boolean | null;
  projectARI?: string | null;
  userARI?: string | null;
};
export type SearchJiraIssueFilter = {
  assigneeARIs?: ReadonlyArray<string> | null;
  commenterARIs?: ReadonlyArray<string> | null;
  issueLabels?: ReadonlyArray<string> | null;
  issueTypeIDs?: ReadonlyArray<string> | null;
  issueTypes?: ReadonlyArray<string> | null;
  projectARIs?: ReadonlyArray<string> | null;
  reporterARIs?: ReadonlyArray<string> | null;
  statusCategories?: ReadonlyArray<SearchIssueStatusCategory> | null;
  watcherARIs?: ReadonlyArray<string> | null;
};
export type SearchJiraProjectFilter = {
  projectType?: SearchProjectType | null;
  projectTypes?: ReadonlyArray<SearchProjectType> | null;
};
export type SearchMercuryFilter = {
  ancestorIds?: ReadonlyArray<string> | null;
  focusAreaTypeIds?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
};
export type SearchTalentFilter = {
  employmentTypes?: ReadonlyArray<string> | null;
  focusAreas?: ReadonlyArray<string> | null;
  jobFamilies?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  statuses?: ReadonlyArray<string> | null;
  teams?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyFilter = {
  additionalTexts?: ReadonlyArray<string> | null;
  ancestorAris?: ReadonlyArray<string> | null;
  assignees?: ReadonlyArray<string> | null;
  containerAris?: ReadonlyArray<string> | null;
  containerNames?: ReadonlyArray<string> | null;
  containerTypes?: ReadonlyArray<string> | null;
  createdBy?: ReadonlyArray<string> | null;
  excludeSubtypes?: ReadonlyArray<string> | null;
  gitFilters?: SearchGitFilters | null;
  integrations?: ReadonlyArray<string> | null;
  labels?: ReadonlyArray<string> | null;
  lastUpdatedBy?: ReadonlyArray<string> | null;
  range?: ReadonlyArray<SearchThirdPartyRangeFilter | null> | null;
  salesforceFilters?: SearchSalesforceFilters | null;
  serviceNowFilters?: SearchServiceNowFilters | null;
  subtypes?: ReadonlyArray<string | null> | null;
  teamsFilters?: SearchTeamsFilters | null;
  thirdPartyProducts?: ReadonlyArray<SearchThirdPartyProduct> | null;
  thirdPartyTypes?: ReadonlyArray<string> | null;
  titleMatchOnly?: boolean | null;
};
export type SearchGitFilters = {
  pullRequestStatus?: ReadonlyArray<string> | null;
  repoName?: ReadonlyArray<string> | null;
  reviewer?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyRangeFilter = {
  field: SearchThirdPartyRangeField;
  gt?: string | null;
  lt?: string | null;
};
export type SearchSalesforceFilters = {
  attributeFilters?: ReadonlyArray<SearchSalesforceAttributeFilter> | null;
  campaignStatuses?: ReadonlyArray<string> | null;
  caseStatuses?: ReadonlyArray<string> | null;
  closeDate?: string | null;
  eventTypes?: ReadonlyArray<string> | null;
  isClosed?: boolean | null;
  knowledgeArticlePublishStatuses?: ReadonlyArray<string> | null;
  leadStatuses?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  stage?: ReadonlyArray<string> | null;
  taskStatuses?: ReadonlyArray<string> | null;
  taskTypes?: ReadonlyArray<string> | null;
};
export type SearchSalesforceAttributeFilter = {
  field: string;
  from?: string | null;
  operator: SearchSalesforceAttributeFilterOperator;
  source: SearchSalesforceAttributeFilterSource;
  to?: string | null;
  value?: string | null;
  values?: ReadonlyArray<string> | null;
};
export type SearchServiceNowFilters = {
  attributeFilters?: ReadonlyArray<SearchServiceNowAttributeFilter> | null;
};
export type SearchServiceNowAttributeFilter = {
  field: string;
  from?: string | null;
  operator: SearchServiceNowAttributeFilterOperator;
  source: SearchServiceNowAttributeFilterSource;
  to?: string | null;
  value?: string | null;
  values?: ReadonlyArray<string> | null;
};
export type SearchTeamsFilters = {
  attachmentFileTypes?: ReadonlyArray<string> | null;
  hasAttachment?: boolean | null;
  hasLink?: boolean | null;
  messageType?: string | null;
  workspaceName?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyProduct = {
  channels?: ReadonlyArray<string | null> | null;
  connectionIds?: ReadonlyArray<string> | null;
  connectorSources?: ReadonlyArray<string> | null;
  connectorSourcesImpersonationEnabled?: ReadonlyArray<string> | null;
  containerTypes?: ReadonlyArray<string> | null;
  datasourceId?: string | null;
  entities?: ReadonlyArray<string> | null;
  integrationId?: string | null;
  linkedEntities?: ReadonlyArray<string> | null;
  linkedEntityGranularity?: SearchLinkedEntityGranularity | null;
  product?: string | null;
  providerId?: string | null;
  subtypes?: ReadonlyArray<string> | null;
};
export type SearchTrelloFilter = {
  isRecentBias?: boolean | null;
};
export type useContentTreeSearchContentTreeSearchQuery$variables = {
  experience: string;
  filters: SearchFilterInput;
  first?: number | null;
  searchText: string;
};
export type useContentTreeSearchContentTreeSearchQuery$data = {
  readonly search: {
    readonly search: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly confluenceEntity?: {
            readonly id?: string;
            readonly metadata?: {
              readonly titleEmojiPublished: {
                readonly id: string | null;
                readonly value: string | null;
              } | null;
            } | null;
            readonly subtype?: ConfluencePageSubType | null;
          } | null;
          readonly content?: ReadonlyArray<{
            readonly subType: string | null;
          } | null> | null;
          readonly entityId?: string | null;
          readonly id: string;
          readonly title: string;
          readonly type: SearchResultType;
        } | null;
      }>;
    } | null;
  } | null;
};
export type useContentTreeSearchContentTreeSearchQuery = {
  response: useContentTreeSearchContentTreeSearchQuery$data;
  variables: useContentTreeSearchContentTreeSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experience"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchText"
},
v4 = [
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "searchText"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "title"
},
v7 = {
  "kind": "ScalarField",
  "name": "type"
},
v8 = {
  "kind": "ScalarField",
  "name": "entityId"
},
v9 = {
  "kind": "ScalarField",
  "name": "subType"
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "subtype"
    },
    {
      "concreteType": "ConfluenceContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "concreteType": "ConfluenceContentTitleEmoji",
          "kind": "LinkedField",
          "name": "titleEmojiPublished",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ]
    }
  ],
  "type": "ConfluencePage"
},
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useContentTreeSearchContentTreeSearchQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
              {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "confluenceEntity",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/)
                            ]
                          }
                        ],
                        "type": "SearchConfluencePageBlogAttachment"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useContentTreeSearchContentTreeSearchQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
              {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "confluenceEntity",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v10/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/)
                                ],
                                "type": "Node",
                                "abstractKey": "__isNode"
                              }
                            ]
                          }
                        ],
                        "type": "SearchConfluencePageBlogAttachment"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "bfd2d03b38af95faa0e469c18e1b2cf6",
    "id": "6cafaee2d45a7afc5e38c864a3f5ffe04fd5e96c5f5a758bfdeb45a38c0a88db",
    "metadata": {},
    "name": "useContentTreeSearchContentTreeSearchQuery",
    "operationKind": "query",
    "text": "query useContentTreeSearchContentTreeSearchQuery($experience:String!,$searchText:String!,$first:Int,$filters:SearchFilterInput!){search{search(experience:$experience,query:$searchText,first:$first,filters:$filters){edges{node{__typename,id,title,type,...on SearchConfluencePageBlogAttachment{entityId,content{subType,id},confluenceEntity{__typename,...on ConfluencePage{id,subtype,metadata{titleEmojiPublished{id,value}}},...on Node{__isNode:__typename,id}}}}}}}}"
  }
};
})();

(node as any).hash = "76aa5766ab06f5005efeab562567672b";

export default node;
